
export { GGUSection } from "/codebuild/output/src4265788598/src/packages/shared-components/src/campaign/GGUSection.tsx"